import { isDemoCluster } from '../demo';

export const hasNoSecurityAgentsEnabled = (
  agentStatuses?: Record<string, boolean>
): boolean => {
  if (!agentStatuses) {
    return true;
  }

  return Object.entries(agentStatuses).every(
    ([clusterId, agentStatus]) => isDemoCluster(clusterId) || !agentStatus
  );
};
